const initialState = {
  userDetails: null,
  currentLang: { lang: 'en', id: 2 },
  articlesList:[],
  projectList:[],
  locationByBook:{},
};
export default initialState;
